var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"component":"demo"}},[_c('video-player',{attrs:{"url":'http://voicecasting.sk/intro/music-tutorial.mp4'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }